import { render, staticRenderFns } from "./sales-order-v5.vue?vue&type=template&id=49d078d8"
import script from "./sales-order-v5.vue?vue&type=script&lang=js"
export * from "./sales-order-v5.vue?vue&type=script&lang=js"
import style0 from "./sales-order-v5.vue?vue&type=style&index=0&id=49d078d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports